'use client';

//* Styles
import BenefitsTemplateStyle from './style';

//* Components
import Hero from '../components/Hero';
import BannerSection from '../components/BannerSection';
import CallToAction from '@/modules/_sections/CallToAction';
import Benefits from '../components/Benefits';

const BenefitsTemplate = ({ pageData }) => {
	return (
		<BenefitsTemplateStyle>
			<Hero {...pageData.hero} />

			<BannerSection {...pageData.second_section} />

			<Benefits {...pageData.benefits} />

			<CallToAction />
		</BenefitsTemplateStyle>
	);
};

export default BenefitsTemplate;
